var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1431 32.1433C30.1431 32.8253 29.8722 33.4793 29.39 33.9616C28.9077 34.4438 28.2537 34.7147 27.5717 34.7147H4.42885C3.74687 34.7147 3.09281 34.4438 2.61058 33.9616C2.12834 33.4793 1.85742 32.8253 1.85742 32.1433V3.85756C1.85742 3.17558 2.12834 2.52152 2.61058 2.03929C3.09281 1.55705 3.74687 1.28613 4.42885 1.28613H21.1431L30.1431 10.2861V32.1433Z",
    fill: "#D7E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1431 32.1433C30.1431 32.8253 29.8722 33.4793 29.39 33.9616C28.9077 34.4438 28.2537 34.7147 27.5717 34.7147H4.42885C3.74687 34.7147 3.09281 34.4438 2.61058 33.9616C2.12834 33.4793 1.85742 32.8253 1.85742 32.1433V3.85756C1.85742 3.17558 2.12834 2.52152 2.61058 2.03929C3.09281 1.55705 3.74687 1.28613 4.42885 1.28613H21.1431L30.1431 10.2861V32.1433Z",
    stroke: "#4147D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1431 20.5723L16.0003 25.7151M16.0003 25.7151L10.8574 20.5723M16.0003 25.7151V11.5723",
    stroke: "#4147D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentReceipt);
export default __webpack_public_path__ + "static/media/payment-receipt.4310b7cfebac008020d1003a7c725402.svg";
export { ForwardRef as ReactComponent };